module.exports = "<div class=\"shopping-cart-modal\">\r\n    Shopping dropdown\r\n</div>\r\n"